import { useIonViewDidEnter } from '@ionic/react'
import { intercom } from '../core'
export default function useEventTracking(event: string) {
  useIonViewDidEnter(() => {
    intercom.trackEvent(event)
  })
}
